module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-energy-university-hero.11979e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-energy-university-hero.jpg
// module id = b46k
// module chunks = 0